export default "<p>add-formas-de-pago works!</p>\n"